import { Pipe, PipeTransform } from '@angular/core';
import { FunctionCategory, normalizeFunctionCategory } from '../enum/function-category.enum';

@Pipe({
  name: 'FunctionCategory',
  standalone: true,
})
export class FunctionCategoryPipe implements PipeTransform {
  transform(value: FunctionCategory | string | null | undefined): string {
    if (typeof value === 'string' && value.startsWith('customer.profile.contactFunctionCategories.')) {
      return value;
    }

    const category = normalizeFunctionCategory(value);

    switch (category) {
      case FunctionCategory.DeliveryNote:
        return 'customer.profile.contactFunctionCategories.deliveryNote';
      case FunctionCategory.CreditReport:
        return 'customer.profile.contactFunctionCategories.creditReport';
      case FunctionCategory.ElectronicInvoice:
        return 'customer.profile.contactFunctionCategories.electronicInvoice';
      case FunctionCategory.Reminder:
        return 'customer.profile.contactFunctionCategories.reminder';
      default:
        return '';
    }
  }
}
